/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHealthCashDotApp} from '../api'

 export const useQueryGetHealthCashDotApp = createReactQueryHook('getHealthCashDotApp', getHealthCashDotApp)
